import { InteractiveContainer, Collapse } from "@jugl-web/ui-kit";
import { cx } from "@jugl-web/utils";
import React from "react";
import { ReactComponent as ChevronIcon } from "./assets/chevron.svg";

export const FaqEntry: React.FC<{
  question: string;
  answer: string;
  isOpen: boolean;
  onOpenSwitch: () => void;
}> = ({ answer, question, isOpen, onOpenSwitch }) => (
  <div
    className={cx(
      "overflow-hidden rounded-2xl px-8 transition-all duration-300 hover:bg-grey-100",
      isOpen ? "bg-grey-100 py-6" : "bg-transparent py-4"
    )}
  >
    <InteractiveContainer
      className="flex cursor-pointer items-center justify-between select-none"
      onClick={onOpenSwitch}
    >
      <div className="flex items-center gap-3 text-lg font-medium text-dark">
        <span className="text-xl leading-none">•</span>
        <span>{question}</span>
      </div>
      <ChevronIcon
        className={cx(
          "text-[#1B1C1F] transition-transform duration-300",
          isOpen && "rotate-180"
        )}
      />
    </InteractiveContainer>
    <Collapse isOpen={isOpen}>
      <div className="pt-4 pl-6 leading-relaxed text-dark-700">{answer}</div>
    </Collapse>
  </div>
);
